import { useEffect, useState } from "react";
import { ToggleSwitchProps } from "./types";

import styles from "./styles.module.scss";

export function ToggleSwitch({
	label,
	icon,
	value = false,
	onChange
}: ToggleSwitchProps) {
	const [isActive, setIsActive] = useState(value);

	useEffect(() => {
		setIsActive(value);
	}, [value]);

	useEffect(() => {
		onChange?.(isActive);
	}, [isActive]);

	return (
		<div className={styles.itemToggle}>
			<div className={styles.label}>
				{icon && <div>{icon}</div>}
				<span className={styles.text}>{label}</span>
			</div>
			<div className={styles.actions}>
				<button
					type="button"
					onClick={() => setIsActive(!isActive)}
					className={
						isActive === true ? styles.activeButton : styles.inactiveButton
					}
				>
					Sim
				</button>
				<button
					type="button"
					onClick={() => setIsActive(!isActive)}
					className={
						isActive === false ? styles.activeButton : styles.inactiveButton
					}
				>
					Não
				</button>
			</div>
		</div>
	);
}
